export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            根据观影热度与用户口碑，精心挑选的优质影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 max-w-7xl mx-auto">
          {/* Card 1 */}
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20featuring%20popular%20action%20and%20drama%20movies%2C%20warm%20golden%20theater%20lighting%2C%20film%20strip%20border%20design%2C%20red%20velvet%20curtain%20background%2C%20Hollywood%20meets%20Asian%20cinema%20aesthetic%2C%20vibrant%20and%20dynamic%20atmosphere&width=600&height=400&seq=cards-01-2026&orientation=landscape"
                alt="热门电影专辑"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">热门</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">热门电影专辑</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                最新院线大片、经典老片一网打尽，动作、喜剧、爱情、科幻类型齐全，高清画质随时畅享。
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-500 font-medium">5000+部</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20scene%20with%20warm%20indoor%20lighting%2C%20modern%20living%20room%20with%20large%20screen%20showing%20drama%20series%2C%20cozy%20viewing%20atmosphere%2C%20popular%20Asian%20drama%20posters%20on%20wall%2C%20cinematic%20color%20grading%2C%20comfortable%20home%20entertainment&width=600&height=400&seq=cards-02-2026&orientation=landscape"
                alt="热播电视剧"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">热播</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">热播电视剧</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                国产剧、韩剧、美剧、日剧同步更新，追剧不等待。古装、都市、悬疑、甜宠满足你的口味。
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-500 font-medium">3000+部</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20spotlights%20and%20cheerful%20atmosphere%2C%20entertainment%20show%20set%20design%2C%20vibrant%20neon%20lights%2C%20game%20show%20elements%2C%20happy%20and%20energetic%20vibe%2C%20Korean%20and%20Chinese%20variety%20show%20style&width=600&height=400&seq=cards-03-2026&orientation=landscape"
                alt="综艺娱乐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 bg-secondary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">热播</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">综艺娱乐</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                热门综艺、搞笑真人秀、音乐竞技、脱口秀，轻松解压好伴侣，随时随地开怀大笑。
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-500 font-medium">800+部</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20colorful%20Japanese%20and%20Chinese%20animation%20characters%2C%20vibrant%20and%20detailed%20art%20style%2C%20cherry%20blossoms%20and%20cityscape%20background%2C%20modern%20anime%20aesthetic%2C%20warm%20and%20dynamic%20color%20palette&width=600&height=400&seq=cards-04-2026&orientation=landscape"
                alt="动漫番剧"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">精选</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">动漫番剧</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                热门国漫、日漫番剧一应俱全，热血、治愈、奇幻、恋爱类型全覆盖，二次元爱好者聚集地。
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-500 font-medium">2000+部</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>

          {/* Card 5 */}
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="relative h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%20with%20nature%20and%20wildlife%20scenes%2C%20planet%20earth%20style%20photography%2C%20warm%20natural%20lighting%2C%20educational%20and%20inspiring%20atmosphere%2C%20cinematic%20landscape%20shots%2C%20professional%20wildlife%20photography%20vibe&width=600&height=400&seq=cards-05-2026&orientation=landscape"
                alt="纪录片频道"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2 py-0.5 bg-secondary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">精选</span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">纪录片频道</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                BBC、Discovery经典纪录片，自然、历史、科技、人文，足不出户看世界，增长见识好选择。
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-500 font-medium">600+部</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}